import { __assign } from "tslib";
import React from 'react';
import { withTranslation, Trans } from '@wix/wix-i18n-config';
import { Column } from '../../components/column';
import { Text } from '../../components/text';
import { mobileFullWidthColumnClassName } from '../../utils/defaults';
import { BdiWrapper } from '../../components/bdi-wrapper';
import { addBorderClasses } from './common';
import MobileDivider from './mobile-divider';
import FooterSocialIcon from './footer-social-icon';
var SocialIconsSectionComponent = function (_a) {
    var buttons = _a.buttons, isVisible = _a.isVisible, shareViaTitle = _a.shareViaTitle, showBorderLeft = _a.showBorderLeft, showBorderRight = _a.showBorderRight, showCustomShareViaTitle = _a.showCustomShareViaTitle, width = _a.width, section = _a.section, t = _a.t, paddingLeft = _a.paddingLeft, paddingRight = _a.paddingRight, isRtl = _a.isRtl, onShareClick = _a.onShareClick;
    return isVisible ? (React.createElement(Column, { cssClass: "html-emails-footer-section " + addBorderClasses({
            showBorderRight: showBorderRight,
            showBorderLeft: showBorderLeft,
            isRtl: isRtl,
        }) + " bigger-column-height " + mobileFullWidthColumnClassName, direction: isRtl ? 'rtl' : 'ltr', verticalAlign: "middle", width: width, paddingLeft: paddingLeft, paddingRight: paddingRight },
        React.createElement(MobileDivider, { section: section, show: showBorderLeft }),
        React.createElement(Text, { align: "center", paddingTop: "0px", paddingBottom: "0px", paddingRight: "10px", paddingLeft: "10px" },
            getShareVia(),
            React.createElement("p", { style: { overflow: 'hidden', whiteSpace: 'nowrap' } }, buttons.map(function (button, index, array) { return (React.createElement(FooterSocialIcon, __assign({ key: button.src, spacing: index + 1 < array.length }, button, { onShareClick: onShareClick, alt: t(button.alt) }))); }))),
        React.createElement(MobileDivider, { section: section, show: showBorderRight }))) : null;
    function getShareVia() {
        if (showCustomShareViaTitle && !shareViaTitle) {
            return null;
        }
        var content = showCustomShareViaTitle ? (React.createElement(BdiWrapper, { text: shareViaTitle })) : (React.createElement(Trans, { i18nKey: "COMPOSER.FOOTER.SHARE_VIA" }));
        return (React.createElement("p", { className: "so-global-footer-text", style: { marginBottom: '10px' } }, content));
    }
};
export var FooterSocialIconsSection = withTranslation()(SocialIconsSectionComponent);
//# sourceMappingURL=footer-social-icons-section.js.map